import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import img from '../../assets/images/logo.svg.js';
import img$1 from '../../assets/images/no_applications.svg.js';
import { useTranslation } from '../../locales/i18n.js';
import styles from './index.module.scss.js';

var NoAppAvailable = function () {
    var t = useTranslation()[0];
    return (jsxs("div", __assign({ className: styles.noApps }, { children: [jsx("img", { className: styles.logo, src: img, alt: "Marigold" }, void 0), jsxs("div", __assign({ className: styles.noAppAvailable }, { children: [jsx("img", { src: img$1, alt: "" }, void 0), jsx("p", { children: t("no-application-available") }, void 0)] }), void 0), jsx("a", __assign({ href: "https://meetmarigold.com/", className: styles.link }, { children: t("explore-marigold") }), void 0)] }), void 0));
};

export { NoAppAvailable as default };
